import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Container, Accordion } from 'react-bootstrap';
import { LandingPageContent } from './LandingPageContentType';

type Props = {
  faqs: LandingPageContent['faqsCollection']['items'];
  dtrOptions: any;
  faqsHeaderLabel: string;
};

export default function LandingPageFAQs({
  faqs,
  dtrOptions,
  faqsHeaderLabel,
}: Props) {
  return (
    <section>
      <Container>
        <h2>{faqsHeaderLabel}</h2>
        <Accordion>
          {faqs.map((faq) => (
            <Accordion.Item key={faq.question} eventKey={faq.question}>
              <Accordion.Header
                as={'h5'}
              >{`${faq.question}?`}</Accordion.Header>
              <Accordion.Body>
                {documentToReactComponents(faq.answer.json, dtrOptions)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}
